// extracted by mini-css-extract-plugin
export default {"previewBox":"customization_previewBox__cNoX0"};